function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconScreenRecorderRecordingButtonRecentProject = function SvgIconScreenRecorderRecordingButtonRecentProject(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m20.208 16.472 4.72-4.72a.752.752 0 0 1 1.28.53v11.38a.76.76 0 0 1-.126.417.754.754 0 0 1-1.154.113l-4.72-4.72m-11.25 5.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-9a2.25 2.25 0 0 0-2.25 2.25v9a2.254 2.254 0 0 0 2.25 2.25",
    style: {
      strokeWidth: 2,
      stroke: "#fff"
    }
  }));
};
export default SvgIconScreenRecorderRecordingButtonRecentProject;